<div class="contrainer-fluid h-fullscreen">
    <div class="row block">
        <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 text-center">
            <div class="card">
                <div class="row">
                    <div class="col authZone">
                        <!-- <Label>CMS</Label> -->
                        <img src="/assets/images/logo-04.png" alt="" class="cpd-logo" style="width: 40%;">
                        <input class="form-control txt_box_space" type="text" placeholder="Username"
                            [(ngModel)]="Username">
                        <input class="form-control txt_box_space" type="password" placeholder="Password"
                            [(ngModel)]="Password" (keyup.enter)="Login()">
                        <button type="submit" class="btn btn-info" (click)="Login()">Login</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>